export default __webpack_public_path__ + "540ced049fe3c3bb168679f4421658f0.jpg";